import { render, staticRenderFns } from "./TypeSelectionDialog.vue?vue&type=template&id=196d3f20"
import script from "./TypeSelectionDialog.vue?vue&type=script&lang=js"
export * from "./TypeSelectionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports